import { useMutation, useQueryClient } from 'react-query';
import { useService } from 'shared/providers';

export function useDeleteDraftContract() {
  const { draftContractService } = useService();
  const queryClient = useQueryClient();
  const mutation = useMutation<void, Error, string>(request => draftContractService.deleteDraftContract(request), {
    onSuccess: () => {
      queryClient.invalidateQueries('draft-contract');
    },
  });

  return mutation;
}
